import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { t } from 'i18next';
import { MainMenu, MainMenuItem } from '../../components/MainMenu';

class AppMenu extends Component {
	static propTypes = {
		categories: PropTypes.array,
		MSNavID: PropTypes.string,
	};

	static defaultProps = {
		categories: [],
		MSNavID: '',
	};

	render() {
		return <MainMenu role="menubar" aria-label={t('Main menu')}>
			{this.props.categories.length > 0 &&
				this.props.categories.map(category =>
					<MainMenuItem key={category.slug} icon={category.icon} title={category.name} href={'/resources/' + category.slug} exact />
				)
			}
			<MainMenuItem icon="resources" title={t('All Resources & Assets')} href="/resources" exact />
			{this.props.MSNavID.length>0 && <MainMenuItem icon="search" title={t('Order Tracking')} href="/order-tracking" exact />}
			<MainMenuItem icon="news" title={t('News')} href="/news" exact />
		</MainMenu>
	}
}

export { AppMenu };



// WEBPACK FOOTER //
// ./src/containers/App/AppMenu.js